import { render } from "./EditUserPage.vue?vue&type=template&id=95cbb4a0"
import script from "./EditUserPage.vue?vue&type=script&lang=js"
export * from "./EditUserPage.vue?vue&type=script&lang=js"

import "./EditUserPage.vue?vue&type=style&index=0&id=95cbb4a0&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__